// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wu_a bik_b"};